// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__dwJUO","province":"styles_province__fzh9Z","input_icon":"styles_input_icon__vOzUq"};